import { render, staticRenderFns } from "./AttributeList.vue?vue&type=template&id=0cd2ff93&"
import script from "./AttributeList.vue?vue&type=script&lang=js&"
export * from "./AttributeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports